module.exports = __webpack_public_path__ + "img/icon-xiaohongshu.a757dbdb.png";